import { Field, FieldProps } from 'formik';
import { FormHelperText, Grid } from '@mui/material';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { PoolSelect, PoolTypography, SelectOption } from '@synergy/components';
import { fields } from '@synergy/utils';
import { paymentMethodTranslationMap } from '@synergy/models';

import { CustomerConditionsFormValues } from '../models/customer-conditions-form-values';
import { CustomerDetailConditionsFact } from './customer-detail-conditions-fact';
import { PaymentTermAutocomplete } from '../../../../../../common/components/payment-term-autocomplete/payment-term-autocomplete';
import { TaxRateAutocomplete } from '../../../../../../common/components/tax-rate-autocomplete/tax-rate-autocomplete';
import { customerConditionSelector } from '../store/customer-conditions-selectors';
import { useAppSelector } from '../../../../../../store/use-appstate-selector';

export const CustomerDetailConditionsPayment = () => {
    const fieldNames = fields<CustomerConditionsFormValues>();
    const { conditions } = useAppSelector(customerConditionSelector);

    const paymentMethodOptions: SelectOption[] = paymentMethodTranslationMap.map(paymentMethod => ({
        value: paymentMethod.value,
        displayValue: <FormattedMessage id={paymentMethod.translationKey} />,
    }));

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
                <PoolTypography
                    sx={{ mb: 1 }}
                    styleType="sectionTitleNew"
                    id="app.contactsAndOrganizations.conditions.payment"
                />
            </Grid>
            <Grid item={true} xs={12}>
                <PaymentTermAutocomplete
                    name={fieldNames.paymentTermId}
                    useId={true}
                    required={true}
                    label={<FormattedMessage id="app.contactsAndOrganizations.detail.paymentTerm" />}
                />
            </Grid>

            <Grid item={true} xs={6}>
                <TaxRateAutocomplete useId={true} />
            </Grid>

            <Grid item={true} xs={6}>
                <Field name={fieldNames.paymentMethod}>
                    {({ field, form, meta }: FieldProps<string>) => (
                        <>
                            <PoolSelect
                                {...field}
                                fullWidth={true}
                                options={paymentMethodOptions}
                                onValueChange={id => form.setFieldValue(field.name, id)}
                                label={<FormattedMessage id="app.contactsAndOrganizations.detail.paymentMethod" />}
                                required={true}
                                error={!!meta.touched && !!meta.error}
                                disallowDefaultValue={true}
                            />
                            {meta.error && meta.touched && (
                                <FormHelperText error={true}>
                                    <FormattedMessage id={meta.error} />
                                </FormHelperText>
                            )}
                        </>
                    )}
                </Field>
            </Grid>

            <Grid item={true} xs={6}>
                <CustomerDetailConditionsFact
                    label={<FormattedMessage id="app.contactsAndOrganizations.conditions.sepaMandate" />}
                    empty={!conditions?.sepaMandate}
                >
                    {conditions?.sepaMandate}
                </CustomerDetailConditionsFact>
            </Grid>

            <Grid item={true} xs={6}>
                <CustomerDetailConditionsFact
                    label={<FormattedMessage id="app.contactsAndOrganizations.conditions.sepaMandateSince" />}
                    empty={!conditions?.sepaMandateDate}
                >
                    {conditions?.sepaMandateDate && (
                        <FormattedDate
                            value={conditions.sepaMandateDate}
                            day="2-digit"
                            month="2-digit"
                            year="numeric"
                        />
                    )}
                </CustomerDetailConditionsFact>
            </Grid>
        </Grid>
    );
};
